export const root = {
  boxShadow:
    "0px 100px 169px rgba(151, 217, 225, 0.07), 0px 50.0488px 84.5825px rgba(151, 217, 225, 0.0532233), 0px 30.1471px 50.9486px rgba(151, 217, 225, 0.0456112), 0px 19.3198px 32.6505px rgba(151, 217, 225, 0.0399626), 0px 12.5216px 21.1614px rgba(151, 217, 225, 0.035), 0px 7.88218px 13.3209px rgba(151, 217, 225, 0.0300374), 0px 4.5288px 7.65367px rgba(151, 217, 225, 0.0243888), 0px 1.99324px 3.36858px rgba(151, 217, 225, 0.0167767);",
  borderForm: "2px solid #DCDCDC;",
};
